export enum ProductDescriptionSection {
  Description = "description",
  Characteristics = "characteristics",
  Specifications = "specifications",
  Games = "games",
  Applications = "applications",
}

export const StockSelectorCssClass = "stock-selector-container";

export const ProductStickyNavConfig: {
  readonly MobileContainerCssClass: string;
  readonly DesktopContainerCssClass: string;
} = {
  MobileContainerCssClass: "mobile-product-nav-container",
  DesktopContainerCssClass: "desktop-product-nav-container",
};
